import IResult from 'src/dataModel/IResult';
import IReq from './IReq';
import IResp from './IResp';
import Urls from 'src/config/Urls';
import http from 'src/utils/ajaxUtils';

/**
 * 接口描述
 * @param param 参数，IReq类型
 */
async function add(param: IReq): Promise<IResult<IResp>> {
  param.city_abbreviation = param.city_abbreviation.toUpperCase();
  param.nation_abbreviation = param.nation_abbreviation.toUpperCase();
  const resp = await http.post(Urls.addDataCenter, param);
  return resp;
}

export default add;


// WEBPACK FOOTER //
// ./src/api/datacenter/add/index.ts